import React, {useCallback, useState} from 'react'
import classNames from 'classnames'
import {useSelector} from 'react-redux'
import Head from "next/head";
import {FormattedMessage} from 'react-intl'
import dynamic from 'next/dynamic'
import InStockProducts from "../shared/InStockProducts";
import cls from "./shop.module.scss"

const ProductCard = dynamic(() => import('../shared/ProductCard'))


function useSetOption(option, filter, dispatch) {
    const callback = useCallback(filter, [])

    return useCallback(
        (data) => {
            dispatch({
                type: 'SET_OPTION_VALUE',
                option,
                value: callback(data),
            })
        },
        [option, callback, dispatch],
    )
}


function ProductsView(props) {
    const {
        length,
        locale,
        isLoading,
        productsList,
        options,
        filters,
        dispatch,
        layout: propsLayout,
        grid,
        offcanvas,
        forPage,
        dbName,
    } = props
    const [layout, setLayout] = useState(propsLayout)


    const customer = useSelector((state) => state.customer)
    const handlePageChange = useSetOption('page', parseFloat, dispatch)
    const handleSortChange = useSetOption(
        'sort',
        (event) => event.target.value,
        dispatch,
    )
    const handleLimitChange = useSetOption(
        'limit',
        (event) => parseFloat(event.target.value),
        dispatch,
    )

    const handleResetFilters = useCallback(() => {
        dispatch({type: 'RESET_FILTERS'})
    }, [dispatch])
    const filtersCount = Object.keys(filters)
        .map((x) => filters[x])
        ?.filter((x) => x).length


    const schemaCategoryPage = {
        "@context": `https://schema.org/`,
        "@type": "Product",
        "name": `Products in Category`,
        "offers": [],
    }


    const inventoryClass = classNames(cls["products-list__item"],
        forPage === 'search' && cls["found-product-card"],
    )

    const productsListItems = productsList['data'].map((product, index) => {

        schemaCategoryPage.offers.push({
            "@type": "ListItem",
            "item": {
                "id": product.url_key,
                "name": product?.name,
                "description": product.description,
            },
        })
        return (
            <React.Fragment key={index}>
                <InStockProducts qty={product?.product_inventories[0]?.qty}>
                    <div className={inventoryClass}>
                        <ProductCard product={product} customer={customer} dbName={dbName}/>
                    </div>
                </InStockProducts>
            </React.Fragment>
        )
    })

    const rootClasses = classNames(cls["products-view"],
        isLoading && cls["products-view--loading"])

    const viewOptionsClasses = classNames(cls["view-options"],
        offcanvas === 'always' && cls["view-options--offcanvas--always"],
        offcanvas === 'mobile' && cls["view-options--offcanvas--mobile"],
    )

    let content


    if (productsList.emptyCategory) {
        content = (
            <div className={cls["products-view__empty"]}>
                <div className={cls["products-view__empty-title"]}>
                    <FormattedMessage
                        id="no_products_yet"
                        defaultMessage="There are no products yet!"
                    />{' '}
                </div>
            </div>
        )
    } else if (productsListItems?.length > 0) {
        content = (
            <div
                className={cls["products-list"]}
                data-layout={layout !== 'list' ? grid : layout}
                data-with-features={
                    layout === 'grid-with-features' ? 'true' : 'false'
                }
            >
                <div className={cls["products-list__body"]}>{productsListItems}</div>
            </div>
        )
    } else {
        content = (
            <div className={cls["products-view__empty"]}>
                <div className={cls["products-view__empty-title"]}>
                    <FormattedMessage
                        id="sorry_nothing_found_for"
                        defaultMessage="No matching items"
                    />{' '}
                </div>
                <div className={cls["products-view__empty-subtitle"]}>
                    <FormattedMessage
                        id="try_reset_filters"
                        defaultMessage="Try to reset filters"
                    />
                </div>
                {!productsList?.data?.length &&
                !Object.keys(filters).length ? null : (
                    <button
                        type="button"
                        className="btn btn-orange btn-sm"
                        onClick={handleResetFilters}
                    >
                        <FormattedMessage id="reset" defaultMessage="Reset"/>
                    </button>
                )}
            </div>
        )
    }

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{__html: JSON.stringify(schemaCategoryPage)}}
                />
            </Head>
            <div className={rootClasses}>
                <div className={cls["products-view__loader"]}/>
                {content}
            </div>
        </>
    )
}

export default ProductsView
